import {
  Button,
  Row,
  Form,
  Input,
  Space,
  Table,
  Col,
  Select,
  Statistic,
  Dropdown,
  Menu,
  Card,
  Empty,
  ConfigProvider,
  Tooltip,
  Spin,
} from "antd";
import { observer } from "mobx-react-lite";
import { useEffect, Fragment } from "react";
import "./index.css";
import {
  CommonStore,
  XNumberManageStore,
  UserAccountStore,
} from "../../../../store";
import type { MenuProps, TableProps, UploadProps } from "antd";
import { DownOutlined, InfoCircleOutlined } from "@ant-design/icons";
import UpdateOrAdd from "./update_or_add";
import TemplatePreview from "./template_preview";
import dictionary from "../../../../utils/dictionary";

const { Column } = Table;

function XNumberManage() {
  const [form] = Form.useForm();
  const { Option } = Select;

  useEffect(() => {
    form.setFieldsValue({
      middleNumberPoolNo: null,
      status: null,
      phoneNumber: "",
      targetPlatform: null,
    });
    resetSearchbth();
    CommonStore.getPlatformCode();
    // CommonStore.getPagePermission("apool_number_management");
  }, []);
  const getFormData = (
    changeValue: powerSearchData,
    allValues: powerSearchData
  ) => {
    console.log(changeValue, allValues);

    XNumberManageStore.setSearchForm({ ...allValues });
  };

  const searchBtn = () => {
    XNumberManageStore.resetPage();
    XNumberManageStore.manageXPoolNumberPage();
  };
  const resetSearchbth = () => {
    XNumberManageStore.setSearchForm({});
    searchBtn();
  };

  // const addProps: UploadProps = {
  //   beforeUpload(info) {
  //     return false
  //   },
  //   onChange: (info) => {
  //     const form = new FormData();
  //     form.append("file", info.file as any);
  //     XNumberManageStore.addPreview(form);
  //   },
  // };

  const handleMenuClick: MenuProps["onClick"] = (e) => {
    if (e.key === "1") {
      return XNumberManageStore.controlAdd();
    }
  };

  // const items = [
  //     {
  //         label: "批量新增",
  //         label: (
  //           <Upload {...addProps} showUploadList={false}>
  //             <span>批量新增</span>
  //           </Upload>
  //         ),
  //         style: {display: CommonStore.pagePermission.manageable ? '' : 'none'},
  //         key: "1",
  //     },
  //     {
  //         key: "2",
  //         label: "下载模版",
  //         children: [
  //             {
  //                 key: "2-1",
  //                 label: (
  //                     <a
  //                         href={require("../../../../assets/template/pool_x_add.xlsx")}
  //                         download={"X池新增模版"}
  //                     >
  //                         <span>新增</span>
  //                     </a>
  //                 ),
  //             },
  //         ],
  //     },
  // ];
  const tableEmptyRender = () => {
    return (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={<>暂无数据</>}
      ></Empty>
    );
  };

  return (
    <Fragment>
      {/*<UpdateOrAdd></UpdateOrAdd>*/}
      {/*<TemplatePreview></TemplatePreview>*/}
      <Spin
        spinning={XNumberManageStore.spinning}
        fullscreen
        size="large"
        tip="数据正在处理中"
      />
      <Row gutter={24} style={{ marginTop: "12px" }}>
        <Col span={4}>
          <Card bordered={false}>
            <Statistic
              title="池号码总数"
              value={XNumberManageStore.statisticsData.totalCount}
              valueStyle={{ color: "#3f8600" }}
            />
          </Card>
        </Col>
        <Col span={4}>
          <Card bordered={false}>
            <Statistic
              title="使用中号码总数"
              value={XNumberManageStore.statisticsData.usingCount}
              valueStyle={{ color: "#3f8600" }}
            />
          </Card>
        </Col>
        <Col span={4}>
          <Card bordered={false}>
            <Statistic
              title="X池禁用数量"
              value={XNumberManageStore.statisticsData.xpoolDisableCount}
              valueStyle={{ color: "#3f8600" }}
            />
          </Card>
        </Col>
        <Col span={4}>
          <Card bordered={false}>
            <Statistic
              title="平台禁用数量"
              value={XNumberManageStore.statisticsData.mpDisableCount}
              valueStyle={{ color: "#3f8600" }}
            />
          </Card>
        </Col>
        <Col span={4}>
          <Card bordered={false}>
            <Statistic
              title="上周新增"
              value={XNumberManageStore.statisticsData.weekBasis}
              valueStyle={{ color: "#3f8600" }}
            />
          </Card>
        </Col>
        <Col span={4}>
          <Card bordered={false}>
            <Statistic
              title="昨日新增"
              value={XNumberManageStore.statisticsData.dayBasis}
              valueStyle={{ color: "#3f8600" }}
            />
          </Card>
        </Col>
      </Row>
      <div style={{ height: "12px" }}></div>
      <div className="formContent">
        <Form
          form={form}
          initialValues={XNumberManageStore.searchForm}
          autoComplete="off"
          labelCol={{ span: 6 }}
          onValuesChange={getFormData}
        >
          <Row justify="start">
            <Col span={8}>
              <Form.Item label="号码" name="phoneNumber">
                <Input placeholder="请输入号码" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <ConfigProvider renderEmpty={tableEmptyRender}>
                <Form.Item label="所属X池" name="middleNumberPoolNo">
                  <Select
                    onChange={UserAccountStore.handleChange}
                    placeholder="请选择所属X池"
                  >
                    {XNumberManageStore.getAllXPoolReadInfo.map(
                      (value: any, index: any) => {
                        return (
                          <Option value={value.no} key={value.no}>
                            {value.name}
                          </Option>
                        );
                      }
                    )}
                  </Select>
                </Form.Item>
              </ConfigProvider>
            </Col>
            <Col span={8}>
              <Form.Item label="号码状态" name="status">
                <Select placeholder="请选择号码状态">
                  {Object.keys(dictionary.status).map((key) => (
                    <Option key={key} value={key}>
                      {dictionary.status[key]}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="平台编码" name="targetPlatform">
                <Select
                  allowClear={true}
                  placeholder="请选择平台编码"
                  options={CommonStore.targetPlatformList.map(item => ({ label: item.value, value: item.value }))}
                ></Select>
              </Form.Item>
            </Col>
            <Col offset={2}>
              <Form.Item>
                <Space>
                  <Button type="primary" onClick={searchBtn}>
                    搜索
                  </Button>
                  <Button htmlType="reset" onClick={resetSearchbth}>
                    重置
                  </Button>
                </Space>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            
            {/*{(CommonStore.pagePermission.writable ||*/}
            {/*    CommonStore.pagePermission.manageable) && (*/}
            {/*    <Col span={8} offset={8}>*/}
            {/*        <Form.Item>*/}
            {/*            <Dropdown*/}
            {/*                dropdownRender={(menu) => (*/}
            {/*                    <Menu*/}
            {/*                        onClick={handleMenuClick}*/}
            {/*                        items={items}>*/}
            {/*                    </Menu>*/}
            {/*                )}*/}
            {/*            >*/}
            {/*                <Button style={{float: "right"}}>*/}
            {/*                    <Space className="change">*/}
            {/*                        变更*/}
            {/*                        <DownOutlined/>*/}
            {/*                    </Space>*/}
            {/*                </Button>*/}
            {/*            </Dropdown>*/}
            {/*        </Form.Item>*/}
            {/*    </Col>*/}
            {/*)}*/}
          </Row>
        </Form>
      </div>
      <ConfigProvider renderEmpty={tableEmptyRender}>
        <Table
          dataSource={XNumberManageStore.tableData.records}
          rowKey={(record: { phoneNumberNo: string }) => record.phoneNumberNo}
          loading={XNumberManageStore.tableLoad}
          scroll={{ x: 1500 }}
          pagination={{
            current: XNumberManageStore.pageData.page,
            pageSize: XNumberManageStore.pageData.size,
            onChange: XNumberManageStore.pageData.changePage,
            pageSizeOptions: [10, 20, 50, 100],
            showSizeChanger: true,
            total: XNumberManageStore.tableData.total,
            showTotal: () => `共计${XNumberManageStore.tableData.total}条`,
            position: ["bottomLeft"],
          }}
        >
          <Column
            ellipsis={true}
            width={120}
            title="号码"
            dataIndex="phoneNumber"
            fixed={"left"}
            sorter={(a: any, b: any) => a.phoneNumber - b.phoneNumber}
            defaultSortOrder={"descend"}
            showSorterTooltip={false}
          />
          <Column
            width={100}
            title="编号"
            dataIndex="phoneNumberNo"
            render={(phoneNumberNo) => (
              <Tooltip placement="topLeft" title={phoneNumberNo}>
                <InfoCircleOutlined />
              </Tooltip>
            )}
          />
          <Column
            ellipsis={true}
            width={150}
            title="所属X池"
            dataIndex="middleNumberPoolName"
          />
          <Column
            ellipsis={true}
            width={100}
            title="所属X池编号"
            dataIndex="middleNumberPoolNo"
            render={(middleNumberPoolNo) => (
              <Tooltip placement="topLeft" title={middleNumberPoolNo}>
                <InfoCircleOutlined />
              </Tooltip>
            )}
          />
          <Column
            width={100}
            title="号码状态"
            ellipsis={true}
            dataIndex="status"
            render={(status) => dictionary.status[status]}
          />
          <Column
            ellipsis={true}
            width={120}
            title="虚拟运营商"
            dataIndex="virtualCarrierName"
          />
          <Column
            ellipsis={true}
            width={120}
            title="基础运营商"
            dataIndex="infraCarrier"
          />
          <Column
            ellipsis={true}
            width={120}
            title="平台编码"
            dataIndex="targetPlatform"
          />
          <Column
            ellipsis={true}
            width={120}
            title="省"
            dataIndex="provinceName"
          />
          <Column ellipsis={true} width={120} title="市" dataIndex="cityName" />
        </Table>
      </ConfigProvider>
    </Fragment>
  );
}

export default observer(XNumberManage);
